export const BADGE_COLORS = {
    TOTAL: "#3A57E8",
    WORKING: "#388E3C",
    NOT_WORKING: "#D32F2F",
} as const;

export const SIZES = {
    AVATAR: 48,
    ACTION_BUTTON: 40,
    BADGE_DOT: 12,
} as const;

export const TIME_INTERVALS = {
    SCHEDULE_EXPIRY_DAYS: 1,
} as const;
